import React from "react";
import { IconChevronDown } from "@tabler/icons-react";

interface Props {
  //message: Message;
  //hoveredMessageId: string | null;
  //activeDropdownId: string | null;
  showActions: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const ChatMessageOptionsDropdown: React.FC<Props> = ({ showActions }) => {
  return (
    <>
      <div className="chat-item-options">
        <a
          className="btn-visito-white btn-actions"
          href="#"
          onClick={showActions}
        >
          <IconChevronDown size={14} />
        </a>
      </div>
    </>
  );
};

export default ChatMessageOptionsDropdown;
